export enum SidebarManageKey {
  publishing = 'publishing',
  versions = 'versions',
  sharing = 'sharing',
  team = 'team',
  monitoring = 'monitoring',
  history = 'history',
  issues = 'issues',
}

export enum SidebarManageName {
  publishing = 'Publishing',
  versions = 'Versions',
  issues = 'Bug & feature requests',
  sharing = 'Sharing',
  manage = 'Manage team',
  monitoring = 'Monitoring',
  history = 'History',
}

export enum SidebarEmbedKey {
  embed = 'embed',
  zapEditor = 'embed-zap-editor',
  workflowElement = 'workflow-element',
  workflowApi = 'workflow-api',
  zapPrefillGenerator = 'prefilled-zaps',
  automaticAccountCreation = 'automatic-account-creation',
  settings = 'embed-settings',
}

export enum SidebarEmbedName {
  automaticAccountCreation = 'Automatic account creation',
  embed = 'Embed Zapier',
  workflowElement = 'Workflow Element',
  workflowApi = 'Workflow API',
  settings = 'Settings',
  zapEditor = 'Zap Editor',
  zapPrefillGenerator = 'Pre-filled Zaps',
}
